export interface PlayerSeasonSummaryTeamModelAPI {
    id: string;
    firstGamePlayed: string;
    lastGamePlayed: string;
    gamesPlayed: number;
    toiSeconds: number;
    toiSecondsES: number;
    toiSecondsPP: number;
    toiSecondsSH: number;
    xgfratio: number;
    soo: number;
    soodiff: number;
    ozstart: number;
}
export interface PlayerSeasonSummaryModelAPI {
    leagueId: string;
    seasonId: string;
    name: string;
    teams: PlayerSeasonSummaryTeamModelAPI[];
}

export interface PlayerModelAPI {
    id: string;
    firstName: string;
    lastName: string;
    birthdate: string;
    birthCity: string;
    birthProvince: string;
    birthCountry: string;
    pictureSrc: string;
    currentSalary: string;
    freeAgencyStatus: string;
    futureFreeAgencyStatus: string;
    freeAgencyYear: string;
    injuryStatus: string;
    primaryPosition: PlayerPrimaryPosition;
    handedness: string;
    currentTeam: {
        id: string;
        jerseyNum: string;
        role: string;
        position: string;
    };
    seasonStagesSummary: PlayerSeasonSummaryModelAPI[];
    seasonsSummary: PlayerSeasonSummaryModelAPI[];
}

export interface PlayersModelAPI {
    leagueid: string;
    leaguename: string;
    seasonid: string;
    seasonname: string;
    players: PlayerModelAPI[];
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface PlayerModel extends PlayerModelAPI {}

export interface KeyedByLeagueSeasonStageId<T> {
    [leagueSeasonStage: string]: T;
}

export interface PlayerStateModel {
    players: KeyedByLeagueSeasonStageId<PlayerModelAPI[]>;
    loading: boolean;
}

export enum PlayerPrimaryPosition {
    F = 'F',
    D = 'D',
    G = 'G',
}

export enum PlayerPosition {
    LW = 'LW',
    RW = 'RW',
    C = 'C',
    D = 'D',
    G = 'G',
}
